export type AnnouncementType = 'notice' | 'alert' | 'warning' | 'info';

export type Announcement = {
    id: number;
    title: string;
    content: string | null;
    type: AnnouncementType;
    type_label: string;
    pinned: boolean;
    active: boolean;
    published_at: string | null;
    expires_at: string | null;
    created_by: string | null;
    created_at: string;
};

export type CompanyEventType = 'holiday' | 'birthday' | 'meeting' | 'event' | 'training';

export type CompanyEvent = {
    id: number;
    title: string;
    description: string | null;
    event_date: string; // YYYY-MM-DD
    end_date: string | null;
    all_day: boolean;
    type: CompanyEventType;
    type_label: string;
    color: string;
    created_at: string;
};

export type DocumentCategory = 'process' | 'governance' | 'hr' | 'procedures' | 'compliance' | 'other';

export type CompanyDocument = {
    id: number;
    title: string;
    description: string | null;
    category: DocumentCategory;
    category_label: string;
    published: boolean;
    sort_order: number;
    updated_at: string;
    content_markdown?: string | null;
    slug?: string | null;
    icon?: string | null;
    current_version?: number;
    updated_at_label?: string;
    updated_by?: string | null;
    requires_approval?: boolean;
    restricted?: boolean;
    can_edit?: boolean;
    pending_count?: number;
    content_html?: string | null;
    feature_links?: FeatureLink[];
    created_by?: string | null;
    created_at_label?: string;
    view_roles?: string[] | null;
    editor_roles?: string[] | null;
    approver_roles?: string[] | null;
    access?: { view: string[] | null; edit: string[]; approve: string[] | null };
    can_approve?: boolean;
    can_manage?: boolean;
};

export type FeatureLink = { label: string; path: string };

export type CompanyDocumentVersion = {
    id: number;
    version: number;
    title: string;
    change_summary: string;
    status: 'pending' | 'approved' | 'rejected';
    is_current: boolean;
    created_by: string | null;
    created_at_label: string;
    reviewed_by: string | null;
    reviewed_at_label: string | null;
    review_note: string | null;
    can_review: boolean;
    content_html?: string | null;
    feature_links?: FeatureLink[];
};

export const DOCUMENT_CATEGORIES: { value: DocumentCategory; label: string }[] = [
    { value: 'process', label: 'Processos' },
    { value: 'governance', label: 'Governança' },
    { value: 'hr', label: 'RH' },
    { value: 'procedures', label: 'Procedimentos' },
    { value: 'compliance', label: 'Compliance' },
    { value: 'other', label: 'Geral' },
];

export const EVENT_TYPE_LABELS: Record<CompanyEventType, string> = {
    holiday: 'Feriado',
    birthday: 'Aniversário',
    meeting: 'Reunião',
    event: 'Evento',
    training: 'Treinamento',
};
